<p-treeSelect
  containerStyleClass="key-account-tree"
  [(ngModel)]="selectedNodeKeyAccount"
  [options]="filteredTreeNodeList"
  [disabled]="disabled"
  [metaKeySelection]="false"
  [selectionMode]="disableCheckboxSelection ? 'single' : 'checkbox'"
  placeholder="Select Key Account"
  [filter]="false"
  (ngModelChange)="onSelectionChange($event)"
>
  <ng-template pTemplate="value">
    <ng-container *ngIf="selectedKeyAccountLeaves.length; else placeholder">
      <div
        class="p-treeselect-label p-treeselect-label-container"
        *ngIf="!disableCheckboxSelection"
      >
        <p-chip
          *ngFor="let node of selectedKeyAccountLeaves"
          [label]="node.label"
          [removable]="false"
        ></p-chip>
      </div>
      <span
        class="p-treeselect-label font-semibold"
        *ngIf="disableCheckboxSelection"
      >
        {{ selectedKeyAccountLeaves[0]?.label }} |
        {{ selectedKeyAccountLeaves[0]?.data?.parentLabel }}
      </span>
    </ng-container>
    <ng-template #placeholder>
      <span class="p-treeselect-label p-placeholder">{{
        "PLANOGRAM_INFO.SELECT_KEY_ACCOUNT" | translate
      }}</span>
    </ng-template>
  </ng-template>
  <ng-template pTemplate="header">
    <div class="custom-search-container">
      <app-search-input
        [iconName]="'icon-search'"
        (searchTextChange)="onCustomFilterChange($event)"
      ></app-search-input>
    </div>
    <div class="select-all-container" *ngIf="!disableCheckboxSelection">
      <p-checkbox
        [(ngModel)]="selectAll"
        [binary]="true"
        (onChange)="onSelectAllChange($event)"
        inputId="selectAll"
      />
      <label for="selectAll" class="select-all-label">{{ 'SHARED.SELECT_ALL' | translate }}</label>
    </div>
  </ng-template>

  <ng-template let-node pTemplate="default">
    <div class="custom-tree-node">
      <span class="node-label">{{ node.label }}</span>
      <span class="node-parent-label" *ngIf="node.data?.parentLabel">
        {{ node.data.parentLabel }}
      </span>
    </div>
  </ng-template>

  <ng-template pTemplate="footer" *ngIf="footerButtonShow">
    <div class="footer-content p-3">
      <div class="flex justify-end gap-3">
        <app-button-secondary
          btnMinWidth="120"
          (actionButtonCall)="closeTreeOverlay(false)"
          [buttonCaption]="'SHARED.CANCEL' | translate"
          buttonClassName="xs-medium"
        >
        </app-button-secondary>

        <app-button-primary
          btnMinWidth="120"
          [buttonCaption]="'SHARED.APPLY' | translate"
          [buttonDisabled]="!hasSelectedKeyAccounts"
          buttonClassName="xs-medium xs-medium-black"
          (actionButtonCall)="closeTreeOverlay(true)"
        >
        </app-button-primary>
      </div>
    </div>
  </ng-template>
</p-treeSelect>
